/* japandco: presentation only. Empire still requests and formats shipping rates. */
(() => {
  if (customElements.get('jdc-shipping-rates')) return;

  class JdcShippingRates extends HTMLElement {
    // Move an existing trailing parenthesis onto its own line, without inferring an ETA.
    static splitLabel(label) {
      const text = label.trim();
      const unchanged = { name: text, detail: '' };
      if (!text.endsWith(')')) return unchanged;

      let depth = 0;
      for (let index = text.length - 1; index >= 0; index -= 1) {
        if (text[index] === ')') depth += 1;
        if (text[index] !== '(') continue;
        depth -= 1;
        if (depth !== 0) continue;

        const name = text.slice(0, index).trim();
        const detail = text.slice(index + 1, -1).trim();
        return name && detail ? { name, detail } : unchanged;
      }
      return unchanged;
    }

    connectedCallback() {
      this.enhance();
      if (!this.observer) this.observer = new MutationObserver(() => this.enhance());
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    enhance() {
      if (!this.processed) this.processed = new WeakSet();
      for (const nameNode of this.querySelectorAll('.jdc-cart__shipping-name')) {
        if (this.processed.has(nameNode)) continue;
        const card = nameNode.closest('li');
        if (!card) continue;
        this.processed.add(nameNode);

        const label = JdcShippingRates.splitLabel(nameNode.textContent);
        if (!label.detail) continue;
        nameNode.textContent = label.name;
        const detail = document.createElement('span');
        detail.className = 'jdc-cart__shipping-detail';
        detail.textContent = label.detail;
        card.append(detail);
      }
    }
  }

  customElements.define('jdc-shipping-rates', JdcShippingRates);
})();

/* Keep the theme's translated postal label when Empire changes the country.
   No cart, address value, request, rate, or recalculation behavior is changed. */
(() => {
  if (customElements.get('jdc-shipping-fields')) return;

  class JdcShippingFields extends HTMLElement {
    connectedCallback() {
      this.localizeZipLabel();
      if (!this.observer) this.observer = new MutationObserver(() => this.localizeZipLabel());
      this.observer.observe(this, { childList: true, characterData: true, subtree: true });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    localizeZipLabel() {
      const label = this.querySelector('label[for="address_zip"]');
      const translatedLabel = this.getAttribute('data-zip-label');
      if (label && translatedLabel && label.textContent.trim() !== translatedLabel) {
        label.textContent = translatedLabel;
      }
    }
  }

  customElements.define('jdc-shipping-fields', JdcShippingFields);
})();
